import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import RichTextBlock, { BLOCKS } from "./RichTextBlock";

export const Title = ({ content, className }) => {
    const renderers = {
        blocks: {
            [BLOCKS.PARAGRAPH]: (_, children) => (
                <h1 className={className}>{children}</h1>
            ),
        },
    };

    return <RichTextBlock content={content} renderers={renderers} />;
};

const Lead = ({ content }) => {
    const renderers = {
        blocks: {
            [BLOCKS.PARAGRAPH]: (_, children) => (
                <p className="my-2">{children}</p>
            ),
        },
    };

    return <RichTextBlock content={content} renderers={renderers} />;
};

const HeaderCopy = ({ title, lead, className }) => {
    return (
        <div className={classNames("header-copy", className)}>
            <Title content={title} />
            {lead && <Lead content={lead} />}
        </div>
    );
};

HeaderCopy.propTypes = {
    title: PropTypes.shape({ raw: PropTypes.string }).isRequired,
    lead: PropTypes.shape({ raw: PropTypes.string }),
};

export default HeaderCopy;
